module.exports = __webpack_public_path__ + "img/explain_01.1f71ad85.jpg";